export default __webpack_public_path__ + "static/media/stat-icon3.3ace2296.svg";